import Render from '@Views/root/restricted.html'
import { Vue, Component } from 'vue-property-decorator'

@Render
@Component({})
export class Restricted extends Vue {
}